const MAX_TIME_HIDDEN = 600000 // 10 min

export default {
  data() {
    return {
      lastHidden: Date.now(),
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
  methods: {
    handleVisibilityChange() {
      if (!document.hidden) {
        const timeHidden = Date.now() - this.lastHidden
        if (timeHidden > MAX_TIME_HIDDEN) window.location.reload()
      } else {
        this.lastHidden = Date.now()
      }
    },
  },
}
